import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

// Resolve public-asset URLs once and expose them as CSS custom properties.
// CRA's CSS loader refuses root-absolute url() references at build time, so
// texture images from public/ are injected as custom properties instead.
const PUBLIC = process.env.PUBLIC_URL || '';
const textureStyle = {
  '--tex-waves':       `url(${PUBLIC}/img/waves-lines.webp)`,
  '--tex-waves-alt':   `url(${PUBLIC}/img/waves-lines-alt.webp)`,
  '--tex-wave':        `url(${PUBLIC}/img/wave.webp)`,
  '--tex-dots-wave':   `url(${PUBLIC}/img/dots-wave.webp)`,
  '--tex-consistent':  `url(${PUBLIC}/img/consistent-lines.webp)`,
};

const Layout = ({ children }) => {
  return (
    <div className="layout" style={textureStyle}>
      <Header />
      <main className="layout__main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
